<template>
    <div>
        <p class="small text-muted font-weight-bold">Nombre de paiements CB : {{ paymentsList.total }}</p>

        <b-table
            :data="paymentsList.data"
            :mobile-cards="true"
            :paginated="true"
            :current-page.sync="page"
            default-sort-direction="desc"
            :striped="true"
            :debounce-search="200"
            class="table-striped"
            :loading="isLoading"
            :default-sort="[sortField, sortOrder]"
            :per-page="paymentsList.per_page"
            :total="paymentsList.total"
            backend-sorting
            backend-pagination
            backend-filtering
            @page-change="onPageChange"
            @sort="onSort"
            @filters-change="onFilterChange"
        >
            <b-table-column
                field="created_at"
                sortable
                :searchable="isSearchable"
                :label="$t('factures.date')"
                cell-class="align-middle"
            >
                <div slot="default" slot-scope="props">
                    {{ moment(props.row.created_at).format('L') }}
                </div>
                <div slot="searchable" slot-scope="props" class="searchableCol">
                    <input
                        v-model="props.filters[props.column.field]"
                        type="date"
                        class="form-control form-control-sm"
                        :placeholder="$t('factures.date')"
                    />
                </div>
            </b-table-column>

            <b-table-column
                field="emailPayant"
                sortable
                :searchable="isSearchable"
                label="Email"
                cell-class="align-middle"
            >
                <div slot="default" slot-scope="props">
                    {{ props.row.emailPayant }}
                    <LoginAs :user-id="props.row.id" />
                </div>
                <div slot="searchable" slot-scope="props" class="searchableCol">
                    <input
                        v-model="props.filters[props.column.field]"
                        type="text"
                        step="0.01"
                        class="form-control form-control-sm"
                        placeholder="Email"
                    />
                </div>
            </b-table-column>

            <b-table-column
                field="price_ht"
                sortable
                :searchable="isSearchable"
                :label="$t('factures.amounHT')"
                cell-class="align-middle"
            >
                <div slot="default" slot-scope="props">
                    <span class="tag">{{ props.row.price_ht }}€</span>
                </div>
                <div slot="searchable" slot-scope="props" class="searchableCol">
                    <input
                        v-model="props.filters[props.column.field]"
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        :placeholder="$t('factures.amounHT')"
                    />
                </div>
            </b-table-column>

            <b-table-column field="invoiceIdFacturation" :label="$t('factures.invoice')" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    <span v-if="props.row.invoiceIdFacturation">
                        <a :href="`${appUrl}/invoicepdf.php?num=${props.row.id}`">
                            <img :src="`${appUrl}/assets/img/pdf.png`" />
                        </a>
                    </span>
                </div>
            </b-table-column>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: 'TabPayments',
        props: ['payments'],

        data: function () {
            return {
                paymentsList: {},

                //buefy data
                isSearchable: true,
                sortField: 'id',
                sortOrder: 'desc',
                filters: '',
                page: 1,
                isLoading: false,

                // data info
                appUrl: process.env.APP_URL,

                //other
                isMobileWidth: window.innerWidth < 768
            }
        },
        watch: {
            payments: {
                handler(newValue) {
                    this.paymentsList = newValue
                },
                deep: true
            }
        },

        created() {
            this.paymentsList = this.payments && this.payments.total && this.payments.total > 0 ? this.payments : {}
        },

        methods: {
            /** Table filtering, sorting and pagination methods */
            loadAsyncData() {
                this.isLoading = true
                var self = this

                this.$emit('loadAsyncData', {
                    page: this.page,
                    sortField: this.sortField,
                    sortOrder: this.sortOrder,
                    filters: this.filters,
                    includes: '',
                    path: this.paymentsList.path,
                    index: this.indexType,
                    per_page: this.perPage,

                    callback() {
                        self.isLoading = false
                    }
                })
            },
            onSort(field, order) {
                this.sortField = field
                this.sortOrder = order

                this.loadAsyncData()
            },

            onFilterChange(filter) {
                var filters = []
                Object.keys(filter).forEach(element => {
                    var currentFilter = {
                        key: element,
                        value: filter[element]
                    }
                    filters.push(currentFilter)
                })
                this.filters = filters
                this.loadAsyncData()
            },

            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            }
        }
    }
</script>
